module.exports = __webpack_public_path__ + "img/logo-team-auth.53e6489e.svg";